import { OverlayPortal } from '@lib/components'
import type React from 'react'

import MainNotificationRules from './MainNotificationRules'
import { NotificationContainer } from './NotificationContainer'

const NotificationWrapper: React.FC<{ isPositionAbsolute?: boolean }> = ({
  isPositionAbsolute = false,
}) => {
  return (
    <OverlayPortal root="notifications">
      <MainNotificationRules />
      <NotificationContainer isPositionAbsolute={isPositionAbsolute} />
    </OverlayPortal>
  )
}

export default NotificationWrapper
